import React from "react";
import classNames from "classnames";

import { Menu } from "@base-ui/react/menu";
import { Icon, IconName } from "../icon";

import "./floating-menu-item.css";

interface IFloatingMenuItemProps {
	text: string | undefined;
	iconName: IconName;
	onClick: () => void;
	disabled?: boolean;
	badgeType?: "warning" | "error" | undefined;
}

export const FloatingMenuItem = ({
	text,
	iconName,
	disabled,
	onClick,
	badgeType,
	ref,
}: IFloatingMenuItemProps & { ref?: React.Ref<HTMLButtonElement> }) => {
	const classes = classNames([
		{
			"floating-menu__badge--warning": badgeType === "warning",
		},
		{
			"floating-menu__badge--error": badgeType === "error",
		},
	]);
	return (
		<Menu.Item className="floating-menu__item" ref={ref} disabled={disabled} onClick={onClick}>
			<div className="floating-menu__item-icon">
				{badgeType && <span className={classes} />}
				<Icon iconName={iconName} />
			</div>
			<span className="floating-menu__item-text">{text}</span>
		</Menu.Item>
	);
};

FloatingMenuItem.displayName = "FloatingMenuItem";
